import { z } from 'zod';
export const storeMetafield = z.object({
    id: z.number(),
    name: z.string(),
    namespace: z.string(),
    key: z.string(),
    createdOn: z.string(),
});
export const platformMetafield = z.object({
    idFromPlatform: z.string(),
    name: z.string(),
    namespace: z.string(),
    key: z.string(),
    description: z.string().nullable(),
});
export const storeMetafieldCreate = platformMetafield.pick({
    idFromPlatform: true,
});
//# sourceMappingURL=storeMetafield.js.map